import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <div className="flex items-center gap-8 md:gap-12">
            <Link
              to="/"
              className={`font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap ${
                isHome && !scrolled ? 'text-white' : 'text-foreground-950'
              }`}
            >
              073漫画网
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  isHome && !scrolled
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
                } ${location.pathname === '/' ? (isHome && !scrolled ? 'text-white' : 'text-primary-500') : ''}`}
              >
                首页
              </Link>
              <Link
                to="/category/rexue"
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  isHome && !scrolled
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
                } ${location.pathname.startsWith('/category') ? (isHome && !scrolled ? 'text-white' : 'text-primary-500') : ''}`}
              >
                分类
              </Link>
              <Link
                to="/about"
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  isHome && !scrolled
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
                } ${location.pathname === '/about' ? (isHome && !scrolled ? 'text-white' : 'text-primary-500') : ''}`}
              >
                关于我们
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button
              className={`hidden md:flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                isHome && !scrolled
                  ? 'bg-white/20 text-white hover:bg-white/30'
                  : 'bg-primary-500 text-white hover:bg-primary-600'
              }`}
            >
              <i className="ri-user-line w-4 h-4"></i>
              <span>登录</span>
            </button>
            <button
              className="md:hidden flex items-center justify-center w-10 h-10"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i
                className={`text-xl ${
                  isHome && !scrolled ? 'text-white' : 'text-foreground-950'
                } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-6 py-4 flex flex-col gap-4">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors">
              首页
            </Link>
            <Link to="/category/rexue" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors">
              分类浏览
            </Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors">
              关于我们
            </Link>
            <button className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap">
              <i className="ri-user-line w-4 h-4"></i>
              <span>登录</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}